import React from "react";
import clsx from "clsx";
import { createTheme } from '@mui/material/styles';
import * as colors from "@material-ui/core/colors";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Container from "@material-ui/core/Container";
import { Link } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";
import HomeIcon from "@material-ui/icons/Home";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import GroupIcon from '@material-ui/icons/Group';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import CircleNotificationsIcon from '@material-ui/icons/Notifications';
import EmailIcon from '@material-ui/icons/Email';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import HistoryEduIcon from '@material-ui/icons/Assignment';
import SnippetFolderIcon from '@mui/icons-material/SnippetFolder';
import { useState, useRef, useEffect } from 'react'
import '../pages/style.css';
import { Box, CircularProgress, Grid, Typography, LinearProgress, Button } from '@material-ui/core'
import User from '../../User';
import { MicNoneTwoTone } from "@mui/icons-material";
import { AUTHORITY_NO_LIST } from "../../Const";
import blackboardLogo from '../../blackboard.svg';



const drawerWidth = 240;

const theme = createTheme({
  typography: {
    fontFamily: [
      "Noto Sans JP",
      "Lato",
      "游ゴシック Medium",
      "游ゴシック体",
      "Yu Gothic Medium",
      "YuGothic",
      "ヒラギノ角ゴ ProN",
      "Hiragino Kaku Gothic ProN",
      "メイリオ",
      "Meiryo",
      "ＭＳ Ｐゴシック",
      "MS PGothic",
      "sans-serif",
    ].join(","),
  },
  palette: {
    primary: { main: colors.blue[800] }, // テーマの色
  },
});






const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    toolbar: {
      paddingRight: 24,
    },
    toolbarIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: "0 8px",
      ...theme.mixins.toolbar,
    },
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      color: "#e0f2f1",
      backgroundColor: "#e46262"
    },
    appBarShift: {
      marginLeft: drawerWidth,
      width: `calc(100% - ${drawerWidth}px)`,
      transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    menuButton: {
      marginRight: 36,
    },
    menuButtonHidden: {
      display: "none",
    },
    title: {
      flexGrow: 1,
    },
    pageTitle: {
      height: "50px",
      marginBottom: theme.spacing(1),
      textDecoration: "underline #e46262",
      textUnderlineOffset: "5px"
    },
    drawerPaper: {
      position: "relative",
      whiteSpace: "nowrap",
      width: drawerWidth,
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerPaperClose: {
      overflowX: "hidden",
      transition: theme.transitions.create("width", {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      width: theme.spacing(7),
      [theme.breakpoints.up("sm")]: {
        width: theme.spacing(9),
      },
    },
    appBarSpacer: theme.mixins.toolbar,
    content: {
      flexGrow: 1,
      height: "100vh",
      overflow: "auto",
    },
    container: {
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(4),
    },
    paper: {
      padding: theme.spacing(2),
      display: "flex",
      overflow: "auto",
      flexDirection: "column",
    },
    link: {
      textDecoration: "none",
      // color: theme.palette.text.secondary,
    },
    linkHide: {
      textDecoration: "none",
      // color: theme.palette.text.secondary,
      display: "none",
    },
  })
);

const Copyright = () => {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" to="/">
        {new Date().getFullYear()} DATT JAPAN Inc
      </Link>{" "}
      {"."}
    </Typography>
  );
};

export interface GenericTemplateProps {
  children: React.ReactNode;
  title: string;
}

const GenericTemplate: React.FC<GenericTemplateProps> = ({
  children,
  title,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const handleDrawerOpen = () => {
    setOpen(true);
  };
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const [isOpen, setIsOpen] = useState(false)
  const menuRef: any = useRef()

  useEffect(() => {
    isOpen && menuRef.current.focus()
  }, [isOpen])


  let jsonlist = JSON.parse(localStorage.getItem("datalist") || '{}')
  // console.log(jsonlist)

  const handleLogout = (e: any) => {
    if (window.confirm('ログアウトして宜しいですか?')) {
      return true
    }
    e.preventDefault()
    return false
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.root}>
        <CssBaseline />
        <AppBar
          position="absolute"
          className={clsx(classes.appBar, open && classes.appBarShift)}
        >
          <Toolbar className={classes.toolbar}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              className={clsx(
                classes.menuButton,
                open && classes.menuButtonHidden
              )}
            >
              <MenuIcon />
            </IconButton>
            <Grid container spacing={0}>
              <Grid item xs={2}>
                <Typography
                  component="h1"
                  variant="h6"
                  color="inherit"
                  noWrap
                  className={classes.title}
                >
                  どこでも臨場
                </Typography>
              </Grid>
              <Grid item xs={6}></Grid>
              <Grid item xs={2}>
                <Typography
                  component="h3"
                  variant="subtitle1"
                  color="inherit"
                  noWrap
                  className={classes.title}
                >
                  {jsonlist.company.company_name}　　{jsonlist.user.user_name}

                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Button
                  className="btnlink"
                  color="primary"
                  variant="contained"
                  size="large"
                  component={Link}
                  to="/logout"
                  onClick={handleLogout}
                  startIcon={(<ExitToAppIcon />)}
                >
                  ログアウト
                </Button>
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(classes.drawerPaper, !open && classes.drawerPaperClose),
          }}
          open={open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List>
            <Link to="/Constructionlist" >
              <ListItem button>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="工事一覧" />
              </ListItem>
            </Link>
            {jsonlist.user.authority_code !== AUTHORITY_NO_LIST.USER.toString() ?
              <Link to="/Userlist" >
                <ListItem button>
                  <ListItemIcon>
                    <GroupIcon />
                  </ListItemIcon>
                  <ListItemText primary="ユーザーリスト" />
                </ListItem>
              </Link>
              : <></>
            }
            <Link to="/Checklist" >
              <ListItem button>
                <ListItemIcon>
                  <CheckCircleOutlineIcon />
                </ListItemIcon>
                <ListItemText primary="チェックリスト一覧" />
              </ListItem>
            </Link>

            <Link to="/BlackBoardCreate" >
              <ListItem button>
                <ListItemIcon>
                  <img src={blackboardLogo} width={25} height={25} alt="黒板のロゴ" />
                </ListItemIcon>
                <ListItemText primary="電子小黒板" />
              </ListItem>
            </Link>
            {/* <a href="https://dokodemo-doboku.jp/lp/" target="_blank">
              <ListItem button>
                <ListItemIcon>
                  <MenuBookIcon />
                </ListItemIcon>
                <ListItemText primary="製品マニュアル" />
              </ListItem>
            </a>
            <a href="https://dokodemo-doboku.jp/lp/" target="_blank">
              <ListItem button>
                <ListItemIcon>
                  <CircleNotificationsIcon />
                </ListItemIcon>
                <ListItemText primary="お知らせ" />
              </ListItem>
            </a>
            <a href="https://dokodemo-doboku.jp/lp/" target="_blank">
              <ListItem button>
                <ListItemIcon>
                  <EmailIcon />
                </ListItemIcon>
                <ListItemText primary="お問い合わせ" />
              </ListItem>
            </a> */}
            <Link to="/Corporate" className={
              (() => {
                if (jsonlist.user.authority_code == AUTHORITY_NO_LIST.SYSTEM_ADMIN) {
                  return classes.linkHide
                } else {
                  return classes.link
                }
              })()
            }>
              <ListItem button>
                <ListItemIcon>
                  <HistoryEduIcon />
                </ListItemIcon>
                <ListItemText primary="契約情報" />
              </ListItem>
            </Link>
            <Link to="/Corporatelist" className={
              (() => {
                if (jsonlist.user.authority_code == AUTHORITY_NO_LIST.SYSTEM_ADMIN) {
                  return classes.link
                } else {
                  return classes.linkHide
                }
              })()
            }>
              <ListItem button>
                <ListItemIcon >
                  <SnippetFolderIcon />
                </ListItemIcon>
                <ListItemText primary="契約企業管理" />
              </ListItem>
            </Link>
          </List>
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Typography
              component="h2"
              variant="h5"
              color="inherit"
              noWrap
              className={classes.pageTitle}
            >
              {title}
            </Typography>
            {children}
            <Box pt={4}>
              <Copyright />
            </Box>
          </Container>
        </main>
      </div>

    </ThemeProvider>
  );
};

export default GenericTemplate;